import { TaiLieu } from "./TaiLieu";

export class KyLuat{
    "id": number;
    "idNhanVien": number;
    "ngayQuyetDinh": Date;
    "soQuyetDinh": string;
    "noiDungKyLuat": string;
    "hinhThucKyLuat": string;
    "nguoiKy": string;
    "chucVuNguoiKy": string;
    "donViKyQuyetDinh": string;
    "dsTaiLieu": Array<TaiLieu>;
}